import React from 'react';
import {
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white rounded-xl px-3 py-2 shadow-warm-md border border-surface-200 text-sm space-y-1">
      <p className="font-semibold text-ink-800">{label}</p>
      {payload.map((p) => (
        <p key={p.dataKey} className="text-ink-500 flex items-center gap-2">
          <span className="inline-block w-2 h-2 rounded-full" style={{ backgroundColor: p.color }} />
          <span>{p.name}:</span>
          <span className="font-medium">
            {p.dataKey === 'dollars'
              ? `$${Math.round(p.value || 0).toLocaleString()}`
              : (p.value || 0).toLocaleString()}
          </span>
        </p>
      ))}
    </div>
  );
};

const ExpenseActivityChart = ({ stats }) => {
  const data = (stats || []).map((s) => ({
    date: s.date?.slice(5) || s.id?.slice(5),
    count: s.expensesCreated || 0,
    dollars: (s.expensesCreatedCents || 0) / 100,
  }));

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-1">
        <h3 className="font-bold text-ink-900 text-[0.9375rem]">Expense volume</h3>
        <span className="text-xs text-ink-400">Last 30 days · count + $ total</span>
      </div>
      <p className="text-xs text-ink-400 mb-5">
        Expenses logged per day (bars) and dollar value of expenses logged (line).
      </p>
      <ResponsiveContainer width="100%" height={300}>
        <ComposedChart data={data} margin={{ top: 5, right: 10, left: -10, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e0d6" vertical={false} />
          <XAxis dataKey="date" tick={{ fontSize: 11, fill: '#57534e' }} axisLine={{ stroke: '#e5e0d6' }} tickLine={false} />
          <YAxis
            yAxisId="left"
            tick={{ fontSize: 11, fill: '#57534e' }}
            axisLine={false}
            tickLine={false}
            allowDecimals={false}
          />
          <YAxis
            yAxisId="right"
            orientation="right"
            tickFormatter={(v) => `$${v >= 1000 ? `${(v / 1000).toFixed(1)}k` : v}`}
            tick={{ fontSize: 11, fill: '#57534e' }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(27, 107, 74, 0.05)' }} />
          <Legend iconType="circle" wrapperStyle={{ fontSize: 12, paddingTop: 8 }} />
          <Bar yAxisId="left" dataKey="count" name="Count" fill="#3BA676" radius={[4, 4, 0, 0]} />
          <Line
            yAxisId="right"
            type="monotone"
            dataKey="dollars"
            name="Dollars"
            stroke="#1B6B4A"
            strokeWidth={2.5}
            dot={{ fill: '#1B6B4A', r: 3, strokeWidth: 2, stroke: 'white' }}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ExpenseActivityChart;
